import apiWrapper, { create } from './helpers';

export default class Adjustment extends apiWrapper('/adjustments') {

  static transfer = opts => create('/adjustments/transfer', opts)

}
